export type StudentCallLog = {
    studentProfileId: number
    customProfileId: string
    studentFullName: string
    staffFullName: string
    createdAt: string
    connectedAt?: string
    endedAt?: string
    duration?: number
    status?: string
    provider?: string
    recordingUrl?: string
    calleePhoneNumber: string
    phone: string
    isInbound: boolean
}

export type CallLogStats = Partial<{
    totalCalls: number
    totalStudents: number
    totalStaffs: number
    totalRecords: number
    totalRecordsInMinutes: number
}>

export enum CallLogStatus {
    Initiated = "initiated",
    Ringing = "ringing",
    Connected = "connected",
    Ended = "ended",
    NoAnswer = "no-answer"
}

export const CallLogStatusOptions = [
    {id: CallLogStatus.Initiated, name: "Initiated"},
    {id: CallLogStatus.Ringing, name: "Ringing"},
    {id: CallLogStatus.Connected, name: "Connected"},
    {id: CallLogStatus.Ended, name: "Ended"},
    {id: CallLogStatus.NoAnswer, name: "No Answer"}
]
